import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AddInviteButton, FullTable, Title } from 'components';
import { DeleteModal, LeftDrawer } from 'fragments';
import { amazonActions, walmartActions } from 'store';
import { walmartBody, walmartHead, ACTION_TYPE, AddWalmartModal } from './fragments';

export const Walmart = ({}) => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [openDel, setOpenDel] = useState(false);
    const [item, setItem] = useState('');

    const history = useHistory();
    const info = history?.location?.state;

    const { amazonProducts } = useSelector((state) => ({
        amazonProducts: state.amazon.amazonProducts,
    }));

    const { walmartProducts } = useSelector((state) => ({
        walmartProducts: state.walmart.walmartProducts,
    }));

    const handleOpenClose = () => {
        setItem('');
        setOpen(!open);
    };

    useEffect(() => {
        dispatch(walmartActions.getWalmart());
    }, []);


    useEffect(() => {
        if (info) {
            dispatch(amazonActions.getAmazon({ ...info }));
            dispatch(amazonActions.getAmazonType());
        }
    }, [info]);


    const handleOpen = (info, type) => {
        setItem(info);
        if (type === 'edit') {
            setOpen(!open);
        }
        if (type === 'delete') {
            setOpenDel(!openDel);
        }
    };

    const handleDelete = () => {
    };

    return (
        <div>
            <div className='title-buttons-wrapper'>
                <div/>
                <div className='buttons-wrapper'>
                    <AddInviteButton text={'Add'} handleClick={handleOpenClose} />
                    <LeftDrawer />
                </div>
            </div>
            <FullTable
                head={walmartHead}
                body={walmartBody}
                loadingType={ACTION_TYPE}
                list={amazonProducts?.mappings}
                listCount={amazonProducts?.count}
                noText={'Product'}
                handleClickButton={handleOpen}
            />
            <DeleteModal
                handleDelete={handleDelete}
                handleOpenClose={() => setOpenDel(!openDel)}
                open={openDel}
                loadType={'DELETE_AMAZON_PRODUCT'}
            />
            <AddWalmartModal
                info={item}
                handleClose={handleOpenClose}
                openModal={open}
                type={'walmart'}
            />
        </div>
    );
};